// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileNotifications__switch-container-ad1393 {
  box-sizing: border-box;
  padding: 12px 24px;
  width: 100%;
  user-select: none;
  --color-icon: var(--base-80);
}

.ProfileNotifications__switch-da3809 {
  margin-inline-start: auto;
  margin-inline-end: 4px;
}

.ProfileNotifications__device-system-actions-bb351b {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  padding: 16px 24px;
}

.ProfileNotifications__device-system-link-fca2de {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  text-decoration: none;
}

.ProfileNotifications__device-system-link-fca2de:hover,
.ProfileNotifications__device-system-link-fca2de:active,
.ProfileNotifications__device-system-link-fca2de:focus-visible {
  text-decoration: underline;
}

.ProfileNotifications__divider-c86999 {
  background-color: var(--base-15);
  min-height: 12px;
  margin: 10px 0;
}

.ProfileNotifications__icon-f69880 {
  margin-inline-end: 24px;
  fill: var(--color-icon);
}

.ProfileNotifications__title-a32e38 {
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/components/ProfileNotifications/ProfileNotifications.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EAEA,4BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AAAF;;AAGA;;;EAGE,0BAAA;AAAF;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,uBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AAAF","sourcesContent":[".switch-container {\n  box-sizing: border-box;\n  padding: 12px 24px;\n  width: 100%;\n  user-select: none;\n\n  --color-icon: var(--base-80);\n}\n\n.switch {\n  margin-inline-start: auto;\n  margin-inline-end: 4px;\n}\n\n.device-system-actions {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  padding: 16px 24px;\n}\n\n.device-system-link {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  text-decoration: none;\n}\n\n.device-system-link:hover,\n.device-system-link:active,\n.device-system-link:focus-visible {\n  text-decoration: underline;\n}\n\n.divider {\n  background-color: var(--base-15);\n  min-height: 12px;\n  margin: 10px 0;\n}\n\n.icon {\n  margin-inline-end: 24px;\n  fill: var(--color-icon);\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch-container": `ProfileNotifications__switch-container-ad1393`,
	"switchContainer": `ProfileNotifications__switch-container-ad1393`,
	"switch": `ProfileNotifications__switch-da3809`,
	"device-system-actions": `ProfileNotifications__device-system-actions-bb351b`,
	"deviceSystemActions": `ProfileNotifications__device-system-actions-bb351b`,
	"device-system-link": `ProfileNotifications__device-system-link-fca2de`,
	"deviceSystemLink": `ProfileNotifications__device-system-link-fca2de`,
	"divider": `ProfileNotifications__divider-c86999`,
	"icon": `ProfileNotifications__icon-f69880`,
	"title": `ProfileNotifications__title-a32e38`
};
module.exports = ___CSS_LOADER_EXPORT___;
